export { default } from './cookie-consent'
